export function titleToHash(title: string): string {
    return title
        .toLowerCase()
        .replace(/[^a-z0-9\s-]/g, '')
        .replace(/\s+/g, '-')
        .replace(/-+/g, '-')
        .replace(/^-|-$/g, '')
}

export function hashToTitle(hash: string, sectionTitles: string[]): string | null {
    if (!hash) return null

    const cleanHash = hash.replace(/^#/, '')

    const exactMatch = sectionTitles.find((title) => titleToHash(title) === cleanHash)
    if (exactMatch) return exactMatch

    const caseInsensitiveMatch = sectionTitles.find(
        (title) => titleToHash(title).toLowerCase() === cleanHash.toLowerCase()
    )

    return caseInsensitiveMatch || null
}
